import browser from "webextension-polyfill";
import * as ewe from "@eyeo/webext-ad-filtering-solution/content-api";
import { ytHavenModalFlag, ytHavenNeverShowOverlayClick, ytHavenOverlayFlag, ytHavenOverlayShown, ytHavenWatchCTAClicked, } from "../shared/index.js";
import { createIframePlayer, createBackdrop, videoContextStore, createLogoSVG, } from "./shared.js";
import { addVideoModal, removeVideoModal } from "./modal-player.js";
import { stopPause } from "./pause-video.js";
import { removeEmbedPlayer } from "./embed-haven.js";
const { short_name: extName } = browser.runtime.getManifest();
let videoOverlay;
function createTitle() {
    const title = document.createElement("span");
    title.innerText = browser.i18n.getMessage("yt_haven_overlay_title", extName);
    title.style.fontWeight = "500";
    title.style.fontSize = "20px";
    title.style.marginBottom = "20px";
    title.style.color = "#fff";
    return title;
}
function createMessage() {
    const message = document.createElement("span");
    message.style.maxWidth = "600px";
    message.style.color = "#fff";
    message.style.fontSize = "14px";
    message.style.lineHeight = "24px";
    message.style.fontFamily = "'Roboto', 'Arial', sans-serif";
    message.style.textAlign = "center";
    message.style.marginBottom = "20px";
    message.innerText = browser.i18n.getMessage("yt_haven_overlay_description", extName);
    return message;
}
function createButton(clickHandler) {
    const button = document.createElement("button");
    button.style.cursor = "pointer";
    button.style.fontSize = "14px";
    button.style.lineHeight = "36px";
    button.style.borderRadius = "18px";
    button.style.border = "none";
    button.style.fontWeight = "500";
    button.style.padding = "0 16px";
    button.style.fontFamily = "'Roboto', 'Arial', sans-serif";
    button.addEventListener("click", () => {
        clickHandler();
    });
    return button;
}
function createWatchButton(clickHandler) {
    const watchButton = createButton(clickHandler);
    watchButton.style.color = "#000";
    watchButton.style.background = "#f1f1f1";
    watchButton.innerText = browser.i18n.getMessage("yt_haven_overlay_cta_button", extName);
    watchButton.addEventListener("mouseover", () => {
        watchButton.style.backgroundColor = "#d9d9d9";
    });
    watchButton.addEventListener("mouseout", () => {
        watchButton.style.backgroundColor = "#f1f1f1";
    });
    return watchButton;
}
function createNeverShowButton(clickHandler) {
    const neverShowButton = createButton(clickHandler);
    neverShowButton.style.backgroundColor = "#333";
    neverShowButton.style.color = "#fff";
    neverShowButton.style.marginLeft = "10px";
    neverShowButton.innerText = browser.i18n.getMessage("yt_haven_overlay_never_button");
    neverShowButton.addEventListener("mouseover", () => {
        neverShowButton.style.backgroundColor = "#555";
    });
    neverShowButton.addEventListener("mouseout", () => {
        neverShowButton.style.backgroundColor = "#333";
    });
    return neverShowButton;
}
function createCTAButtons(watchHandler, neverShowHandler) {
    const watchButton = createWatchButton(watchHandler);
    const neverShowButton = createNeverShowButton(neverShowHandler);
    const buttonContainer = document.createElement("div");
    buttonContainer.appendChild(watchButton);
    buttonContainer.appendChild(neverShowButton);
    return buttonContainer;
}
function getVideoOverlay(watchHandler, neverShowHandler) {
    const backdropElem = createBackdrop();
    const logoElem = createLogoSVG();
    logoElem.style.marginBottom = "1.25rem";
    logoElem.style.display = "block";
    logoElem.style.height = "3.75rem";
    const titleElem = createTitle();
    const descriptionElem = createMessage();
    const buttonContainer = createCTAButtons(watchHandler, neverShowHandler);
    backdropElem.appendChild(logoElem);
    backdropElem.appendChild(titleElem);
    backdropElem.appendChild(descriptionElem);
    backdropElem.appendChild(buttonContainer);
    return backdropElem;
}
export async function insertOverlayExp(videoContainer) {
    const isOverlayIframeExp = await ewe.experiments.getFlag(ytHavenOverlayFlag);
    const isOverlayModalExp = await ewe.experiments.getFlag(ytHavenModalFlag);
    if (!isOverlayIframeExp && !isOverlayModalExp) {
        return;
    }
    removeVideoOverlay();
    const watchHandler = () => {
        if (isOverlayIframeExp) {
            removeVideoOverlay();
            const { videoId, playlistId, startSeconds } = videoContextStore.getVideoContext();
            const playerElem = createIframePlayer({
                videoId,
                playlistId,
                startSeconds,
                showWatchingWith: true,
            });
            videoContainer.appendChild(playerElem);
        }
        else {
            addVideoModal(document.body);
        }
        void browser.runtime.sendMessage({
            type: ytHavenWatchCTAClicked,
        });
    };
    const neverShowHandler = () => {
        var _a;
        void browser.runtime.sendMessage({
            type: ytHavenNeverShowOverlayClick,
        });
        stopPause();
        (_a = videoOverlay === null || videoOverlay === void 0 ? void 0 : videoOverlay.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(videoOverlay);
    };
    videoOverlay = getVideoOverlay(watchHandler, neverShowHandler);
    videoContainer.style.position = "relative";
    videoContainer.style.overflow = "hidden";
    videoContainer.appendChild(videoOverlay);
    void browser.runtime.sendMessage({
        type: ytHavenOverlayShown,
    });
}
export function removeVideoOverlay() {
    var _a;
    (_a = videoOverlay === null || videoOverlay === void 0 ? void 0 : videoOverlay.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(videoOverlay);
    removeEmbedPlayer();
    removeVideoModal();
}
